import { Box, Text, styled } from '@chilipiper/design-system'

export const StyledCopyLink = styled(Text)`
  color: ${props => props.theme.colors['teal-dark-100']};
  font-weight: ${props => props.theme.fontWeights[600]};
  text-decoration: underline;
  text-decoration-color: rgba(0, 159, 199, 0.3);
  white-space: nowrap;
`

export const StyledContainer = styled(Box)`
  margin: 0 1px;
  & + & {
    border-top: 1px solid ${props => props.theme.colors['neutral-light-48']};
  }
`
